import React from 'react';
import classNames from 'classnames';
import { MapPin } from 'lucide-react';

import { hollowIconDefaults } from '../../util/iconSettings';
import { FormattedMessage } from '../../util/reactIntl';
import { Heading } from '../Heading/Heading';

import css from './ApproximateLocation.module.css';

/**
 * Shared public presentation for a privacy-protected listing location.
 */
const ApproximateLocation = props => {
  const {
    className,
    rootClassName,
    headingClassName,
    headingId,
    labelId = 'ApproximateLocation.label',
    descriptionId = 'ApproximateLocation.description',
    showDescription = true,
    compact = false,
  } = props;
  const classes = classNames(rootClassName || css.root, className, {
    [css.compact]: compact,
  });

  return (
    <div className={classes}>
      {headingId ? (
        <Heading as="h3" rootClassName={headingClassName}>
          <FormattedMessage id={headingId} />
        </Heading>
      ) : null}
      <div className={css.content}>
        <MapPin className={css.icon} {...hollowIconDefaults} aria-hidden="true" />
        <div className={css.copy}>
          <p className={css.label}>
            <FormattedMessage id={labelId} />
          </p>
          {showDescription ? (
            <p className={css.description}>
              <FormattedMessage id={descriptionId} />
            </p>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default ApproximateLocation;
